<template>
  <v-card>
    <v-layout mx-4 pt-4 wrap>
      <v-flex md8>
        <v-text-field
          name="name"
          label="Nome"
          id="name"
          v-model="customer.name"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-text-field
          name="taxId"
          label="CPF"
          id="taxId"
          v-model="customer.taxId"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <DatePicker
          name="dateOfBirth"
          label="Nasc"
          id="dateOfBirth"
          v-model="customer.dateOfBirth"
        ></DatePicker>
      </v-flex>
      <v-flex md4>
        <v-text-field
          name="nationalId"
          label="RG"
          id="nationalId"
          v-model="customer.nationalId"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-select
          :items="genderOptions"
          v-model="customer.gender"
          label="Sexo"
        ></v-select>
      </v-flex>
      <v-flex md8>
        <v-text-field
          name="profession"
          label="Profissão"
          id="profession"
          v-model="customer.profession"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-checkbox
          value="1"
          label="Aceite LGPD"
          type="checkbox"
          v-model="customer.acceptedGDPR"
        ></v-checkbox>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
import DatePicker from "@/components/Shared/DatePicker";
export default {
  components: {
    DatePicker
  },
  props: ["customer"],
  data() {
    return {
      genderOptions: [
        { value: 1, text: "Masculino" },
        { value: 2, text: "Feminino" },
        { value: 0, text: "Outro" }
      ]
    };
  }
};
</script>
